import React from 'react';

export default function IconView() {
  return (
    <div>index</div>
  )
}
